var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.4209,
    cy: 35.3311,
    r: 35,
    fill: "#FFE0EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2344_2366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2066 47.1088C24.2066 48.8811 25.8138 50.3311 27.778 50.3311H42.0638C44.028 50.3311 45.6352 48.8811 45.6352 47.1088V27.7755H24.2066V47.1088ZM29.8673 36.7816C29.1709 36.1533 29.1709 35.1383 29.8673 34.5099C30.5638 33.8816 31.6888 33.8816 32.3852 34.5099L34.9209 36.7816L37.4388 34.5099C38.1352 33.8816 39.2602 33.8816 39.9566 34.5099C40.653 35.1383 40.653 36.1533 39.9566 36.7816L37.4388 39.0533L39.9566 41.3249C40.653 41.9533 40.653 42.9683 39.9566 43.5966C39.2602 44.2249 38.1352 44.2249 37.4388 43.5966L34.9209 41.3249L32.403 43.5966C31.7066 44.2249 30.5816 44.2249 29.8852 43.5966C29.1888 42.9683 29.1888 41.9533 29.8852 41.3249L32.403 39.0533L29.8673 36.7816ZM45.6352 22.9422H41.1709L39.903 21.7983C39.5816 21.5083 39.1173 21.3311 38.653 21.3311H31.1888C30.7245 21.3311 30.2602 21.5083 29.9388 21.7983L28.6709 22.9422H24.2066C23.2245 22.9422 22.4209 23.6672 22.4209 24.5533C22.4209 25.4394 23.2245 26.1644 24.2066 26.1644H45.6352C46.6173 26.1644 47.4209 25.4394 47.4209 24.5533C47.4209 23.6672 46.6173 22.9422 45.6352 22.9422Z",
    fill: "#FE5C73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2344_2366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20.4209 20.3311)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9857401d8dd68761051500ab96e3d986.svg";
export { ForwardRef as ReactComponent };